import axios from 'axios'
import { Url } from './constantUrl'
import getHeaders from './getHeaders'
import * as types from './types'
import { errorHandler } from './error/errorHandler.action'
import { LOGIN_AUTH } from './types';
import { notify } from '../services/notification'
import { HTTP_STATUS } from '../constants/httpsStatus/httpsStatus'

//Redemption List GET API 
export const remptionlistAction = () => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.REDEMPTION_LIST
  let options = Object.assign({ method: 'GET'})
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(resp => {
    if (resp.status === 201) {
        dispatch({ type: types.GET_REDEMPTION_LIST, payload: resp })
      return resp
    } else { return null } })
    .catch(error => {
      errorHandler(error)
  })
}

//User Type List GET API 
export const userTypelistAction = () => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.USER_TYPE + '?user_types=can_redeem'
  let options = Object.assign({ method: 'GET'})
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(resp => {
    if (resp?.status === HTTP_STATUS.SUCCESS) {
        dispatch({ type: types.GET_USER_TYPE_LIST, payload: resp })
      return resp
    } else { return null } })
    .catch(error => {
      errorHandler(error)
  })
}

export const scanListAction = () => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.SCAN_LIST
  let options = Object.assign({ method: 'GET'})
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(resp => {
    if (resp.status === HTTP_STATUS.SUCCESS) {
        dispatch({ type: types.GET_SCAN_LIST, payload: resp })
      return resp
    } else { return null } })
    .catch(error => {
      errorHandler(error)
  })
}
export const refferalPointsAction = () => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.REFFRAL_POILICY
  let options = Object.assign({ method: 'GET'})
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(resp => {
    if (resp.status === HTTP_STATUS.SUCCESS) {
        dispatch({ type: types.GET_REFERRAL_POINTS, payload: resp })
      return resp
    } else { return null } })
    .catch(error => {
      errorHandler(error)
  })
}
export const refferalAction = () => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.GET_REFERRAL_LIST
  let options = Object.assign({ method: 'GET'})
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(resp => {
    if (resp.status === HTTP_STATUS.SUCCESS) {
        dispatch({ type: types.GET_REFERRAL_LIST, payload: resp })
      return resp
    } else { return null } })
    .catch(error => {
      errorHandler(error)
  })
}
// Create Redemption POST API 
export const postredemptionlistAction = (params = {}) => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.POST_REDEMPTION
  let options = Object.assign({ method: 'POST' }, params ? { data: params } : null)
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(resp => {
    if (resp.status === 201) {
      dispatch({ type: types.POST_REDEMPTION, payload: resp })
      return resp
    } else { return null }
  }).catch(error => {
    errorHandler(error)})
}

// Create Redemption POST API 
export const postscanlistAction = (params = {}) => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.POST_SCANLIMIT
  let options = Object.assign({ method: 'POST' }, params ? { data: params } : null)
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(resp => {
    if (resp.status === HTTP_STATUS.SUCCESS) {
      dispatch({ type: types.POST_REDEMPTION, payload: resp })
      return resp
    } else { return null }
  }).catch(error => {
    errorHandler(error)})
}
export const postRefferalAction = (params = {}) => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.POST_REFFERAL
  let options = Object.assign({ method: 'POST' }, params ? { data: params } : null)
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(resp => {
    if (resp.status === HTTP_STATUS.SUCCESS) {
      dispatch({ type: types.POST_REFERRAL, payload: resp })
      return resp
    } else { return null }
  }).catch(error => {
    errorHandler(error)})
}